module.exports = __webpack_public_path__ + "media/img/corporate/swiss-e51c4cc2650d6782103d99f166f91734.png";